export default __webpack_public_path__ + "static/media/ritefill_logo.d1902c6e.png";